import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const CancelPayOrderLocal = () => gql`
  mutation CancelPayOrderLocal($params: CancelPayOrderLocalParams!) {
    cancelPayOrderLocal(params: $params) {
      status
      id
    }
  }
`;

export type CancelPayOrderLocalMutationParams = ResolverParams<{
  orderUuid: string;
}>;

export type CancelPayOrderLocalMutationResponse = {
  cancelPayOrderLocal: Order;
};
